<template>
  <div id="clients" v-if="showWindow">


    <vs-popup classContent="popup-example" title="Add Affiliate" :active.sync="popupAddAffiliate">
       
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
           Username
           <vs-input class="inputx w-full" v-model="pars.username" />
         </div>
       </div>
       
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
           Banks
           <v-select v-model="selectedBanks" label="bank" :options="bank" multiple :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="updateParams" />
         </div>
       </div>
       <div class="vx-row mb-6" v-for="(bankDetail, index) in selectedBankDetails" :key="index">
          <div class="vx-col w-full">
              <div>{{`${bankDetail.bank.bankName} ${bankDetail.bank.iban} ${bankDetail.bank.currency}` }}</div>
              <vs-input
                  class="inputx w-full"
                  v-model="bankDetail.commission"
                  placeholder="Enter commission as percent(0-100)"
              />
          </div>
      </div>

      <div class="vx-row mb-6">
         <div class="vx-col w-full">
           PSP
           <v-select v-model="selectedPsps" label="psp" :options="psp" multiple :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="updateParams" />
         </div>
       </div>
       <div class="vx-row mb-6" v-for="(pspDetail, index) in selectedPspDetails" :key="index">
          <div class="vx-col w-full">
              <div>{{`${pspDetail.psp.display}`}}</div>
              <vs-input
                  class="inputx w-full"
                  v-model="pspDetail.commission"
                  placeholder="Enter commission as percent(0-100)"
              />
          </div>
      </div>
      <div class="vx-row mb-6">
         <div class="vx-col w-full">
           Password
           <vs-input class="inputx w-full" v-model="pars.password" />
           <button @click="generatePassword">Generate</button>
         </div>
       </div>
       
       
       
 
       <div class="vx-row mb-6">
         <div class="vx-col w-full">
           <vs-button @click="sendData('add-affiliate')" color="primary" type="filled">Insert</vs-button>
         </div>
       </div>
     </vs-popup>

     
      
       
     
 
     <vs-button color="warning" type="border" class="mr-3 mb-2" @click="popupAddAffiliate=true">Add Affiliate</vs-button>
     

    <table-view 
      :end-point="endPoint"
      :column-defs="tableColumnDefs"
      :filters="filters"
      :key="componentKey"
      :banksObject="banksObject"
      :pspsObject="pspsObject"
      @cell-double-clicked="onCellDoubleClicked"
       
       
      >
    </table-view>
  </div>
</template>

<script>

import tableView from '../../components/tableView';
import vSelect from 'vue-select';
import axios from "@/axios.js";


export default {
  components: {   
    tableView,
    'v-select': vSelect
  },
  data() {
    
    let data = {
      //params:{},
      endPoint:'brokers',
      filters: {
        brokers: true,
        ver_status: true,
      },
      sitePars: new URLSearchParams(),
      selectedBanks: [],
      selectedPsps:[],
      popupAddAffiliate: false,
      pars:{password: ''},
      bank: [],
      psp:[],
      banksObject: [],
      pspsObject:[],
      psps: [],
      selectedBankDetails: [],
      selectedPspDetails:[],
      tableColumnDefs: this.setupColumnDefs(),
      componentKey: 0,
      buttons:{
          remove_broker_bank: true,
          remove_broker_psp: true,
          add_broker_bank: true,
          add_broker_psp: true
      }


    }

    
    data.columnDefs = JSON.parse(localStorage.getItem('brokersColumns'))
 
     
    return data;
  },
  computed: {
    showWindow(){
      if(this.$route.path==='/brokers'){
        return true;
      }
      return false;
    },
  },
  mounted() {
     

    this.getData('get-banks')
    this.getData('get-psps')
  },
  methods:{
    updateParams() {
            /*
           this.sitePars.delete('banks[]');

           const selectedBankObjects = this.banksObject.filter(bank => 
                this.selectedBanks.includes(bank.display)
            );

           
            selectedBankObjects.forEach(bank => {
              // Assuming you want to append the bank name and other details
              this.sitePars.append('banks[]', JSON.stringify({
                  iban: bank.iban,
                  commission:'',
                  currency: bank.currency
              }));
          });
          */
          // Filter the full bank objects based on the selected display values
            this.selectedBankDetails = this.banksObject.filter(bank => 
                this.selectedBanks.includes(bank.display)
            ).map(bank => {
                return {
                    bank: bank,
                    commission: '' // Initialize commission as empty
                };
            });

            this.selectedPspDetails = this.pspsObject.filter(psp => 
                this.selectedPsps.includes(psp.display)
            ).map(psp => {
                return {
                    psp: psp,
                    commission: '' // Initialize commission as empty
                };
            });
    },
    sendData: function(type,data){
         
         let that = this;
         const params = new URLSearchParams();
         params.append('type', type);
         switch(type){
         
           case 'add-affiliate':
                params.append('username', this.pars.username);
                let banksArray = this.selectedBankDetails.map(bankDetail => {
                    return {
                        iban: bankDetail.bank.iban,
                        commission: bankDetail.commission,
                        currency: bankDetail.bank.currency
                    };
                });

                let pspArray = this.selectedPspDetails.map(pspDetail => {
                    return {
                        pspTlId: pspDetail.psp.pspTlId,
                        commission: pspDetail.commission
                    };
                });
                 
                params.append('banks',JSON.stringify(banksArray) )
                params.append('psps',JSON.stringify(pspArray) )
                params.append('password',this.pars.password )
             
            break;
            case 'remove-affiliate':
            var list= this.gridApi.getSelectedRows();
                var ids = ''
                 
                for (let i in list) {
                    ids += ','+list[i].ticket_id;
                }
                ids = ids.substring(1);
                params.append('tl_id', ids);
             break;
       

            default:
                return false;
           
         }
         this.$vs.loading();
         axios.post("/api/banking",params)
        
         .then((data) => {
           that.$vs.loading.close();
           if(data.data[0].out1==='done!'){

             that.componentKey += 1;
             that.popupAddAffiliate=false;
             
             that.openAlert('success','Success',data.data[0].out1);
           } else{
             that.openAlert('danger','Failed',data.data[0].out1);
           }
           })
         .catch((error) => { console.log('e',error); that.$vs.loading.close(); that.openAlert('danger','Failed'); })
       },
       getData: function(type){
         
         let that = this;
         const params = new URLSearchParams();
         params.append('type', type);
         
         axios.post("/api/banking",params)
        
         .then((data) => {
           
           if(data.data[0].object){

            if(type === 'get-banks'){
              this.banksObject = JSON.parse(data.data[0].object);
          
            
              this.bank = this.banksObject.map(item => item.display);
                
            }

            else if(type === 'get-psps'){
              this.pspsObject = JSON.parse(data.data[0].object);
          
            
              this.psp = this.pspsObject.map(item => item.display);
              
            }

           
             
              
           } else{
             that.openAlert('danger','Failed',data.data[0].out1);
           }
           })
         .catch((error) => { console.log('e',error); that.$vs.loading.close(); that.openAlert('danger','Failed'); })
       },
       generatePassword() {
       let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
       let password = '';
       for (let i = 0; i < 8; i++) {
         let randomIndex = Math.floor(Math.random() * characters.length);
         password += characters[randomIndex];
       }
 
       this.pars.password = password;
 
     },
     openAlert(color,title,text) {
       let colorAlert = color;
       this.$vs.notify({
           title: title,
           text: text,
           color: colorAlert
       })
     },
     onCellDoubleClicked(e){

      switch(e.colDef.field){
        case 'remove_aff':
          const affToken = e.data.link.split('=').pop();
          console.log(affToken)
            if(!affToken)
                return false;

          this.sendData('remove-affiliate',{token: affToken})
        break;
      } 
    },
    setupColumnDefs() {
     
     const columnDefs = JSON.parse(localStorage.getItem('brokersColumns'));
     const bankColumn = columnDefs.find(col => col.headerName === 'banks');
     const linkColumn = columnDefs.find(col => col.headerName === 'link');
     const pspColumn = columnDefs.find(col => col.headerName === 'psps');
     if (bankColumn) {
      bankColumn.cellRendererFramework = 'brokerBanks';
     }
     if (linkColumn) {
      linkColumn.cellRendererFramework = 'brokerLink';
     }

     if (pspColumn) {
      pspColumn.cellRendererFramework = 'brokerpsp';
     }

     let firstColumns = {
       headerName: 'Select',
       field: 'select',
        
       width: 125,
       checkboxSelection: true,
       headerCheckboxSelectionFilteredOnly: true,
       headerCheckboxSelection: true,
       
     }
     columnDefs.unshift(firstColumns);
      
     return columnDefs;
   }
    /*
    linkCellRenderer(params){
      const links = JSON.parse(params.value);
     
      if (Array.isArray(links) && links.length > 0){
        const cellDiv = document.createElement('div');
         

          links.forEach(linkObj => {
            if (linkObj.linkAddress) {
            
              const url = new URL(linkObj.linkAddress);
              const shortenedLink = url.hostname.substring(0, 5);

              const linkElement = document.createElement('a');
              //linkElement.href = linkObj.linkAddress;
              linkElement.textContent = shortenedLink;
              linkElement.setAttribute('data-url', linkObj.linkAddress);

              cellDiv.classList.add('link_element')

              linkElement.addEventListener('click', function(event) {   
                event.preventDefault();
                let dataType = this.getAttribute('data-url');
                console.log('Data-Type:clicked ',dataType);         
              });

              cellDiv.appendChild(linkElement);

            }
          });

          // Close the div tag
          
          
          return cellDiv.outerHTML;
      }
      else{
          return '<div>No Links</div>'
      }
      
     
    }*/
    

     //aaa
  },
 
}
</script>


